<template>
  <ul
    class="tw:hidden tw:md:flex tw:md:flex-col tw:md:gap-4 tw:md:items-center tw:bg-gray-100 tw:rounded-xl tw:border tw:border-gray-300 tw:p-6"
  >
    <li v-for="card in cards" :key="card.id">
      <StudioPlusBenefitsCard :item="card" :isExpanded="card.id === expandedCardId" @onCardClick="cardClickHandler" />
    </li>
  </ul>
</template>

<script setup>
import { ref } from 'vue'

import StudioPlusBenefitsCard from '@/components/productPage/studioPlus/benefits/StudioPlusBenefitsCard.vue'

defineProps({
  cards: {
    type: Array,
    required: true,
  },
})

const expandedCardId = ref(null)

const cardClickHandler = ({ itemId }) => {
  expandedCardId.value = expandedCardId.value === itemId ? null : itemId
}
</script>
